import styled from 'styled-components';

import Text from 'components/_core/Text';

export const Description = styled(Text).attrs({
  size: 'sm',
})`
  display: block;
`;

export const Icon = styled.img``;

export const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StepChildren = styled.div`
  > * + * {
    margin-top: ${({ theme }) => theme.spacings.abs8}px;
  }
`;

export const StepContent = styled.div``;

export const Title = styled(Text).attrs({ variant: 'primary' })`
  display: block;
  font-weight: 500;
  margin-bottom: ${({ theme }) => theme.spacings.abs16}px;
`;

export const TrailingLine = styled.div`
  width: 2px;
  flex-grow: 1;
  margin-bottom: -${({ theme }) => theme.spacings.abs32}px;

  background: ${({ theme }) => theme.colors.lightBlue(4)};
`;

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 48px 1fr;
  row-gap: ${({ theme }) => theme.spacings.abs32}px;
  column-gap: ${({ theme }) => theme.spacings.abs16}px;
  padding: ${({ theme }) => theme.spacings.abs24}px;
`;
